import { computed } from 'vue';
import { OfferSchema, Thing } from '@/types/productServerApi';
import useProductDetailData from '@/shared/product/details/useProductDetailData';

export default function useProductDetailJsonLd() {
    const { productData } = useProductDetailData();

    const jsonLd = computed(() => {
        const productJsonLd = productData.value.productJsonLd;

        if (!productJsonLd) {
            return null;
        }

        const { name, image, brand, offers, description, sku, productID, ...json } = productJsonLd;

        return {
            '@context': json['@content'],
            '@type': json['@type'],
            name,
            image: image ?? [],
            brand: getSortedBrand(brand),
            offers: getSortedOffers(offers),
            description,
            sku,
            productID,
        };
    });

    return {
        jsonLd,
    };
}

function getSortedBrand(brand?: Thing) {
    return brand ? {
        '@type': brand['@type'],
        name: brand.name,
    } : undefined;
}

function getSortedOffers(offers: OfferSchema[]) {
    return offers.map(({ priceCurrency, price, availability, url, priceValidUntil, image, ...offer }) => ({
        '@type': offer['@type'],
        priceCurrency,
        price,
        availability,
        url,
        priceValidUntil,
        image,
    }));
}
